import { render, staticRenderFns } from "./trade.vue?vue&type=template&id=1b5d5e89&scoped=true&"
import script from "./trade.vue?vue&type=script&lang=ts&"
export * from "./trade.vue?vue&type=script&lang=ts&"
import style0 from "./trade.vue?vue&type=style&index=0&id=1b5d5e89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5d5e89",
  null
  
)

export default component.exports